import { render, staticRenderFns } from "./MoveToBarRow.vue?vue&type=template&id=0b9ab7d6&scoped=true&"
import script from "./MoveToBarRow.vue?vue&type=script&lang=js&"
export * from "./MoveToBarRow.vue?vue&type=script&lang=js&"
import style0 from "./MoveToBarRow.vue?vue&type=style&index=0&id=0b9ab7d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ab7d6",
  null
  
)

export default component.exports